const mergeComposedFormValueState = (a, b) => Object.entries(b).reduce(
  (result, [partKey, partState]) => ({
    ...result,
    [partKey]: { ...result[partKey], ...partState }
  }),
  { ...a }
);
export {
  mergeComposedFormValueState
};
//# sourceMappingURL=merge-composed-form-value-state.js.map
